/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import Toolbar from "../../../../components/tasklayout/toolbar/Toolbar";
import Buttons from "../../../../components/ui/button/Buttons";
import DropDown from "../../../../components/finalForms/ui/inputs/dropdown/DropDown";
import { TASK_GRID_SELECTION_MODE } from "../../../../components/tasks/NewTaskGrid";
import ToastService from "../../../../services/toastService/ToastService";
import { getTeamPlanningMessageType, isTeamPlanningSuccessMessage } from "../../utils/teamPlanningResponse";
import { normalizeUniquePlanningTasks } from "../../utils/normalizePlanningTasks";

import { useAddTeamTasksMutation } from "../../../../app/services/teamTaskAPI";
import { useGetAllTeamProjectListMutation } from "../../../../app/services/teamProjectsAPI";
import { useLazyGetAllTaskByPlanningTeamMemberQuery } from "../../../../app/services/taskAPI";

const TeamTaskPlanning = (props) => {
  const teamId = props.teamData.teamId;
  const teamPlanningId = props.teamData.planningId || props.teamData.teamPlanningId;
  const isReadOnly = props.isReadOnly === true;

  const [taskList, setTaskList] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

  const [getAllTaskByPlanningTeamMember, {
    isLoading: isTasksByPlanningTeamMemberLoading,
    isFetching: isTasksByPlanningTeamMemberFetching,
    isSuccess: isTasksByPlanningTeamMemberSuccess,
    data: TasksByPlanningTeamMemberData,
  }] = useLazyGetAllTaskByPlanningTeamMemberQuery();

  const [addTeamTasks, {
    isSuccess: isTeamTasksAdded,
    data: addTeamTasksData,
  }] = useAddTeamTasksMutation();

  const [getAllTeamProjectList, {
    isSuccess: isTeamProjectListSuccess,
    data: isTeamProjectListData,
  }] = useGetAllTeamProjectListMutation();

  useEffect(() => {
    if (teamId) {
      getAllTeamProjectList({
        pagination: { pageNumber: 1, pageSize: 250 },
        filters: { searchText: "" },
        teamId,
      });
    }
  }, [teamId]);

  useEffect(() => {
    if (isTeamProjectListSuccess && isTeamProjectListData?.dataSource?.length) {
      const options = isTeamProjectListData.dataSource.map((item) => ({
        label: item.projectName,
        value: item.projectId,
      }));
      setProjectOptions(options);
      setSelectedProjectId((currentProjectId) => {
        if (currentProjectId && options.some((option) => String(option.value) === String(currentProjectId))) {
          return currentProjectId;
        }

        return options[0]?.value ?? null;
      });
    }
  }, [isTeamProjectListSuccess, isTeamProjectListData]);

  useEffect(() => {
    if (teamPlanningId) {
      getAllTaskByPlanningTeamMember(teamPlanningId);
    }
  }, [teamPlanningId]);

  useEffect(() => {
    if (isTasksByPlanningTeamMemberSuccess && TasksByPlanningTeamMemberData) {
      setHasLoadedOnce(true);
      const filterData = selectedProjectId
        ? TasksByPlanningTeamMemberData.filter(
            (item) => String(item.projectId) === String(selectedProjectId)
          )
        : TasksByPlanningTeamMemberData;
      const normalizedTasks = normalizeUniquePlanningTasks(filterData);
      setTaskList(normalizedTasks);
    }
  }, [
    isTasksByPlanningTeamMemberSuccess,
    TasksByPlanningTeamMemberData,
    selectedProjectId,
  ]);

  useEffect(() => {
    if (isTeamTasksAdded && addTeamTasksData) {
      const message = addTeamTasksData.errorMessage;
      ToastService[getTeamPlanningMessageType(message)](message);
      if (!isTeamPlanningSuccessMessage(message)) {
        return;
      }
      props.onSuccess?.();
      setSelectedRows([]);
      getAllTaskByPlanningTeamMember(teamPlanningId);
    }
  }, [isTeamTasksAdded, addTeamTasksData]);

  const handleRefreshGrid = () => {
    getAllTaskByPlanningTeamMember(teamPlanningId);
  };

  const onSave = () => {
    if (isReadOnly) return;
    if (!selectedRows.length || !selectedProjectId) {
      ToastService.warning("Select at least one task and a project");
      return;
    }

    const teamTaskTimeList = selectedRows.map((item) => ({
      taskId: item.taskId ?? item.id,
      remainingHours: item.remTime ?? item.remainingHours ?? item.estimateHours ?? 0,
    }));

    addTeamTasks({
      projectId: selectedProjectId,
      teamTaskTimeList,
      teamId,
      planningId: teamPlanningId,
    });
  };

  const isInitialLoad = isTasksByPlanningTeamMemberLoading && !hasLoadedOnce;

  return (
    <div className="col-12">
      {!isReadOnly && <div className="d-flex align-items-center justify-content-end flex-wrap gap-2 mb-2">
        <div className="task-grid-dropdown" style={{ minWidth: 220 }}>
          <DropDown
            title="Project"
            type="dropdown"
            options={projectOptions}
            value={selectedProjectId}
            placeholder="Select Project"
            isSearchable={true}
            onChange={(option) => setSelectedProjectId(option?.value ?? null)}
          />
        </div>
        <Buttons
          buttonTypeClassName="theme-btn"
          onClick={onSave}
          buttonText={`Save${selectedRows.length ? ` (${selectedRows.length})` : ""}`}
          isDisable={selectedRows.length === 0}
        />
      </div>}
      <Toolbar
        listOnly
        projectId={selectedProjectId || 0}
        taskListData={taskList}
        isTeamPlanning={false}
        allowEditStatus={!isReadOnly && Boolean(selectedProjectId)}
        allowEditAssignee={!isReadOnly && Boolean(selectedProjectId)}
        isShowActualTime={false}
        isShowRemainingTime={true}
        isDataLoading={isInitialLoad}
        isRefreshing={isTasksByPlanningTeamMemberFetching && hasLoadedOnce}
        onRefreshGrid={handleRefreshGrid}
        selectionMode={isReadOnly ? undefined : TASK_GRID_SELECTION_MODE.PLANNING}
        onSelectionChange={setSelectedRows}
      />
    </div>
  );
};

export default TeamTaskPlanning;
